import services from "@/services";

const state = {
  items: [],
  vouchersByCampaign: [],
  campaigns: [],
};

const getters = {
  getVoucherItems: (state) => state.items,
  getVoucherByCampaign: (state) => state.vouchersByCampaign,
  getCampaigns: (state) => state.campaigns,
};

const mutations = {
  setVoucherItems: (state, items) => {
    state.items = items;
  },
  setVoucherByCampaigns: (state, data) => {
    state.data = data;
  },
  setCampaigns: (state, data) => {
    state.campaigns = data;
  },
};

const actions = {
  getAllVoucher({ commit, dispatch }) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .get("voucherglobal")
        .then((response) => {
          commit("setVoucherItems", response.data.data.vouchers);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  putVoucher({ commit, dispatch }, payload) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .put("voucherglobal", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  deleteVoucher({ commit, dispatch }, code) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .delete("voucherglobal/" + code)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  getAllCampaign({ commit, dispatch }, payload) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .get("campaign", payload)
        .then((response) => {
          commit("setCampaigns", response.data.data.items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  getAllVoucherByCampaign({ commit }, { id, payload }) {
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .get(`campaign/${id}/voucher`, payload)
        .then((response) => {
          commit("setVoucherByCampaigns", response.data.data.items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
    });
  },
  postVoucherRegisterMember({ dispatch }, { code, payload }) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true })
    return new Promise((resolve, reject) => {
      services
        .post(`voucher/${code}/reserve`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        }).finally(()=>{
          dispatch("setLoadingGlobal", false, { root: true })
        })
    });
  },
  postAutoApply({ dispatch }, payload) {
    services.setHeader();
    return new Promise((resolve, reject) => {
      services
        .post(`voucher-auto-apply`, payload)
        .then((response) => {
          dispatch(
            "updateLocalGlobalSettings",
            {
              voucher_auto_apply: payload,
            },
            { root: true }
          );
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
